import { Component, Fragment } from 'react';
import styled, { css } from 'styled-components';
import { size, fontSize } from '../../../../../common/css/setting/variable';
interface IProps {
  title: string;
  description?: string;
  linkUrl?: string;
  imageUrl?: string;
  customLoggerParam: string;
}

const InnerStyle = css`
  display: flex;
  align-items: stretch;
  padding: 8px 0;
  border-bottom: 1px solid ${props => props.theme.news.palette.bor_lv2_pc};
`;

const Icon = styled.span<{ $imageUrl: IProps['imageUrl'] }>`
  display: block;
  flex-shrink: 0;
  width: ${size.thumbnail_notice_common};
  height: ${size.thumbnail_notice_common};
  margin-right: 8px;
  background-image: url(${({ $imageUrl }) => $imageUrl});
  background-repeat: no-repeat;
  background-position: left center;
  background-size: contain;
`;

const Title = styled.p`
  width: 100%;
  font-size: ${fontSize.px14};
  line-height: 1.3;
`;

const NoLink = styled.div`
  ${InnerStyle}
`;

const Link = styled.a`
  ${InnerStyle}

  &:visited ${Title} {
    color: ${props => props.theme.news.palette.link_visited_pc};
  }

  &:hover {
    text-decoration: none;
    background-color: ${props => props.theme.news.palette.bg_hover_subColumn_pc};

    ${Title} {
      color: ${props => props.theme.news.palette.link_hover_pc};
      text-decoration: underline;
    }
  }
`;

const Text = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
`;

const Description = styled.p`
  width: 100%;
  margin-top: 4px;
  font-size: ${fontSize.px12};
  line-height: 1.3;
  color: ${props => props.theme.news.palette.text_sub_lv2_common};
`;

export default class NoticeItemSubColumn extends Component<IProps> {
  /**
   *
   */
  public render() {
    const noticeBody = (
      <Fragment>
        {this.props.imageUrl ? <Icon $imageUrl={this.props.imageUrl} /> : null}
        <Text>
          <Title>{this.props.title}</Title>
          {this.props.description ? <Description>{this.props.description}</Description> : ''}
        </Text>
      </Fragment>
    );
    const noticeWrapper = !this.props.linkUrl ? (
      <NoLink>{noticeBody}</NoLink>
    ) : (
      <Link href={this.props.linkUrl} data-cl-params={this.props.customLoggerParam}>
        {noticeBody}
      </Link>
    );
    return <div>{noticeWrapper}</div>;
  }
}
